import { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from './ProductCard';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProductsGrid = ({ onAddToCart, onRequestQuote }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        setProducts(response.data);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="bg-gray-50 py-20" data-testid="products-loading">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
            <span className="ml-3 font-medium text-gray-600">Loading Products...</span>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="bg-gray-50 py-20" data-testid="products-error">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center py-20">
            <p className="text-red-600 font-medium">{error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section 
      id="products" 
      className="bg-gray-50 py-20"
      data-testid="products-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Special Offers
          </span>
          <h2 
            className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4"
            data-testid="products-title"
          >
            Premium HVAC Systems
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            All systems include Air Handler, Condenser, Thermostat, Heating Element, 
            standard installation by factory trained technicians, and all permits.
          </p>
        </div>

        {/* Products Grid */}
        <div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          data-testid="products-grid"
        >
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={onAddToCart}
              onRequestQuote={onRequestQuote}
            />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Not sure which system is right for you?
          </p>
          <button 
            onClick={() => onRequestQuote(null)}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 font-semibold rounded-lg transition-colors"
            data-testid="products-contact-cta"
          >
            Get a Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductsGrid;
